// 常量定义
import {SOCIAL_VENDOR_DINGTALK, SOCIAL_VENDOR_QLINYUN,SOCIAL_VENDOR_QLINYUNDEV, SOCIAL_VENDOR_WECHAT} from "@mods/service/base";

export const SOCIAL_SOURCE_MAP = {
    [SOCIAL_VENDOR_DINGTALK]: {
        id: SOCIAL_VENDOR_DINGTALK,
        label: SOCIAL_VENDOR_DINGTALK,
        title: "钉钉",
        color: "#2D8CF0",
        icon: "md-globe",
        button: "primary",
        img_sm: "/assets/img/social/dingtalk_16x16.png"
    },
    [SOCIAL_VENDOR_WECHAT]: {
        id: SOCIAL_VENDOR_WECHAT,
        label: SOCIAL_VENDOR_WECHAT,
        title: "微信",
        color: "#19BE6B",
        icon: "md-flask",
        button: "success",
        img_sm: "/assets/img/social/wechat_16x16.png"
    },
    [SOCIAL_VENDOR_QLINYUN]: {
        id: SOCIAL_VENDOR_QLINYUN,
        label: SOCIAL_VENDOR_QLINYUN,
        title: "麒麟云",
        color: "#BE03FC",
        icon: "md-flash",
        button: "warning",
        img_sm: "/assets/img/social/qlinyun_16x16.png"
    },
    [SOCIAL_VENDOR_QLINYUNDEV]: {
        id: SOCIAL_VENDOR_QLINYUNDEV,
        label: SOCIAL_VENDOR_QLINYUNDEV,
        title: "麒麟云测试",
        color: "#BE03FC",
        icon: "md-flash",
        button: "warning",
        img_sm: "/assets/img/social/qlinyun_16x16.png"
    }
};
